module.exports = __webpack_public_path__ + "img/youshi.d95a3253.png";